import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { CDN_TYPE_CMS, imageUrlCDN, isUrlAbsolute } from 'utils';

import { SiteConfigManager } from '@atlas/core';

const PARENT_TARGET = '_parent';
const SELF_TARGET = '_self';

const TopEventBanner = ({
  banner: {
    action_url: actionUrl,
    action_url_target: actionUrlTarget = SELF_TARGET,
    image_url: imageUrl,
  },
}) => {
  const renderImage = useMemo(() => {
    const src = SiteConfigManager.getConfig('config.config.useBannersFromConfig', false)
      ? imageUrl
      : imageUrlCDN(imageUrl, CDN_TYPE_CMS);

    return <img alt="banner" className="swiper-lazy sports-slider-img" src={src} />;
  }, [imageUrl]);

  const target = useMemo(() => {
    if (actionUrlTarget !== SELF_TARGET) {
      return actionUrlTarget;
    }

    return actionUrl.startsWith('http') ? PARENT_TARGET : actionUrlTarget;
  }, [actionUrl, actionUrlTarget]);

  const content = useMemo(() => {
    if (!actionUrl) {
      return <div className="top-event-banner">{renderImage}</div>;
    }

    return (
      <>
        {isUrlAbsolute(actionUrl) ? (
          <a className="top-event-banner" href={actionUrl} target={target}>
            {renderImage}
          </a>
        ) : (
          <Link className="top-event-banner" target={target} to={actionUrl}>
            {renderImage}
          </Link>
        )}
      </>
    );
  }, [actionUrl, renderImage, target]);

  return <div className="sports-slider-item-container">{content}</div>;
};

export default TopEventBanner;
